export interface IGetCustomerRevenue {
  skip: number;
  take: number;
  plantId: string;
  year: string;
  customerId?: string;
  mainCustomerId?: string;
  type?: string;
  headerRow?: any;
}

export interface IGetCustomerGroupRevenue {
  skip: number;
  take: number;
  plantId?: string;
  year?: string;
  month?: string;
  fromDate?: string;
  toDate?: string;
  type?: string;
  headerRow?: any;
  customerId?: string;
  mainCustomerId?: string;
}

export interface IGetTeamSaleRevenue {
  skip: number;
  take: number;
  plantId?: string;
  fromDate?: string;
  toDate?: string;
  type?: string;
  headerRow?: any;
  year_?: number;
  month_?: number;
  routeId?: string;
  teamSalesId?: string;
}

export interface IGetTransactionFrequency {
  skip: number;
  take: number;
  plantId?: string;
  year?: string;
  month?: string;
  type?: string;
  headerRow?: any;
  customerId?: string;
  mainCustomerId?: string;
}

export interface IGetMarketCoverage {
  skip: number;
  take: number;
  plantId?: string;
  year?: string;
  month?: string;
  type?: string;
  headerRow?: any;
}

export interface IGetSaleLineEfficiency {
  skip: number;
  take: number;
  plantId?: string;
  year?: string;
  month?: string;
  type?: string;
  headerRow?: any;
}

export const REPORT_VARIABLES = {
  getCustomerRevenue: ({ skip, take, ...input }: IGetCustomerRevenue) => {
    return {
      skip,
      take,
      input: {
        ...(input.plantId && { plantId: input.plantId }),
        ...(input.year && { year: input.year }),
        ...(input.customerId && { customerId: input.customerId }),
        ...(input.mainCustomerId && { mainCustomerId: input.mainCustomerId }),
      },
    };
  },
  getCustomerGroupRevenue: ({
    skip,
    take,
    ...input
  }: IGetCustomerGroupRevenue) => {
    return {
      skip,
      take,
      input: {
        ...(input.plantId && { plantId: input.plantId }),
        ...(input.customerId && { customerId: input.customerId }),
        ...(input.mainCustomerId && { mainCustomerId: input.mainCustomerId }),
        ...(input.fromDate && { fromDate: input.fromDate }),
        ...(input.toDate && { toDate: input.toDate }),
      },
    };
  },
  getTeamSaleRevenue: ({ skip, take, ...input }: IGetTeamSaleRevenue) => {
    return {
      skip,
      take,
      input: {
        ...(input.plantId && { plantId: input.plantId }),
        ...(input.routeId && { routeId: input.routeId }),
        ...(input.teamSalesId && { teamSalesId: input.teamSalesId }),
        ...(input.year_ && { year_: input.year_ }),
        ...(input.month_ && { month_: input.month_ }),
      },
    };
  },
  getTransactionFrequency: ({
    skip,
    take,
    ...input
  }: IGetTransactionFrequency) => {
    return {
      skip,
      take,
      input: {
        ...(input.plantId && { plantId: input.plantId }),
        ...(input.year && { year: input.year }),
        ...(input.month && { month: input.month }),
        ...(input.customerId && { customerId: input.customerId }),
        ...(input.mainCustomerId && { mainCustomerId: input.mainCustomerId }),
      },
    };
  },
  getMarketCoverage: ({ skip, take, ...input }: IGetMarketCoverage) => {
    return {
      skip,
      take,
      input: {
        ...(input.plantId && { plantId: input.plantId }),
        ...(input.year && { year: input.year }),
        ...(input.month && { month: input.month }),
      },
    };
  },
  getSaleLineEfficiency: ({ skip, take, ...input }: IGetSaleLineEfficiency) => {
    return {
      skip,
      take,
      input: {
        ...(input.plantId && { plantId: input.plantId }),
        ...(input.year && { year: input.year }),
        ...(input.month && { month: input.month }),
      },
    };
  },
};
